import { IRequestWithPageSortFilterSearch, TFilters, TOrderBy } from 'redux/types';
import { TVatReimbursementsRequest } from '../vatReimbursement/types';

export type TSwedBankStore = {
	swedBankIntegration: TSwedBankIntegrationResponsePayload;
	swedBankIntegrationLoader: boolean;
	uploadStatementFileLoader: boolean;
	searchInvoicesLoader: boolean;
	searchInvoices: TSwedBankSearchInvoicesResponsePayload;
	markAsProcessedLoader: boolean;
	attachVatReimbursementLoader: boolean;
};

// ==========================================:

export type TSwedBankIntegrationRequestPayload = IRequestWithPageSortFilterSearch;

// export interface ISwedBankIntegrationItem {
// 	id: number;
// 	docNum: number;
// 	paymentDate: string;
// 	clientIBAN: string;
// 	clientName: string;
// 	bank: string;
// 	amount: number;
// 	processedDate: string;
// 	paymentDescription: string;
// 	regNum: string;
// 	easInvoiceNumber: string;
// 	status: SwedBankIntegrationStatus;
// }

export interface ISwedBankIntegrationItem {
	id: number;
	internalInvoiceId: number;
	paymentDate: string;
	debitorBankAccount: string;
	debitorName: string;
	bankRefenceNumber: string;
	amount: number;
	currency: string;
	createdAt: string;
	paymentInformation: string;
	endToEndId: string;
	easInvoiceNumber: string;
	status: SwedBankIntegrationStatus;
	iossReimbursementNumber: string | null;
	debitorCountry: string;
}

export enum SwedBankIntegrationStatus {
	PROCESSED_STATUS = 'processed',
	NO_INVOICE_STATUS = 'no_invoice',
	TO_BE_MANUALLY_PROCESSED_STATUS = 'not_processed',
	SKIPPED_STATUS = 'skipped',
}

export enum SwedBankMarkAsProcessedType {
	ATTACHED = 'attached',
	PAID = 'paid',
	SKIPPED = 'skipped',
}

export type TSwedBankIntegrationResponse = {
	data: ISwedBankIntegrationItem[];
	totalCount: number;
};

export type TSwedBankIntegrationResponseData = TSwedBankIntegrationResponse | null;
export type TSwedBankIntegrationResponsePayload = TSwedBankIntegrationResponseData;

// ==========================================:

export type TSwedBankUploadStatementFileRequest = FormData;

// ==========================================:

export type TSwedBankSearchInvoicesRequestPayload = {
	emId: number | null;
	invoiceNumber: number | null;
};

export enum SwedBankSearchInvoicesPaymentStatus {
	PAID = 'paid',
	PENDING = 'pending',
	PARTIALLY_PAID = 'partially_paid',
	OVERDUE = 'overdue',
}

export type TSwedBankSearchInvoicesItem = {
	invoiceNumber: number;
	invoiceReferenceNumber: number;
	year: number;
	month: number;
	paymentStatus: SwedBankSearchInvoicesPaymentStatus;
	amount: number;
	emFullName: string;
};

export type TSwedBankSearchInvoicesResponse = TSwedBankSearchInvoicesItem[];

export type TSwedBankSearchInvoicesResponseData = TSwedBankSearchInvoicesResponse | null;
export type TSwedBankSearchInvoicesResponsePayload = TSwedBankSearchInvoicesResponseData;

// ==========================================:

export type TSwedBankMarkAsProcessedRequestPayload = {
	incomingPaymentId: number;
	type: string;
	invoiceNumber: number | null;
};

export type TSwedBankMarkAsProcessedRequest = {
	body: TSwedBankMarkAsProcessedRequestPayload;
	swedBankIntegrationRequest: TSwedBankIntegrationRequestPayload;
};

// ==========================================:

export type TAttachVatReimbursementRequest = {
	body: {
		vatReimbursementId: number;
		incomingPaymentId: number;
	};
	swedBankIntegrationRequest: TSwedBankIntegrationRequestPayload;
};
